<template>
  <div class="container flex-content">
    <div style="height: 100%">
      <nav-bar class="nav_fixed">
        <i slot="left-icon" class="public_icon icon-back"></i>
        <div slot="center">我的资料</div>
      </nav-bar>
      <div class="blue_bg"></div>
      <div class="content">
        <div class="myprofile_img">
          <img src="../../assets/images/my_profile.png" alt="" />
        </div>
        <div class="myprofile_info">
          <div class="input_item">
            <div class="flex">
              <label class="item_lable" for="name">
                <i class="red_font start_red">*</i>姓名</label
              >
              <input
                class="left_info"
                :class="{ bgc: isPay }"
                id="name"
                placeholder="请输入姓名"
                :disabled="isPay"
                v-model="name"
              />
              <van-icon name="arrow" />
            </div>
            <!-- <p class="err-aux" v-show="isTelErrAux">
                *只能输入中文
              </p> -->
          </div>
          <div class="input_item">
            <div class="flex">
              <div class="item_lable"><i class="red_font start_red">*</i>手机号</div>
              <div class="left_info" @click="changeTel">{{ telPhone }}</div>
              <van-icon name="arrow" />
            </div>
          </div>
          <div class="input_item">
            <div class="flex">
              <label class="item_lable" for="cardNumber">
                <i class="red_font start_red">*</i>身份证号</label
              >
              <input
                class="left_info"
                :class="{ bgc: isPay }"
                id="cardNumber"
                autocomplete="off"
                maxlength="18"
                onkeyup="value=value.replace(/[^\X0-9]/g, '')"
                placeholder="请输入身份证号"
                :disabled="isPay"
                v-model="cardNumber"
              /><van-icon name="arrow" />
            </div>
          </div>
        </div>
        <span style="font-size: 12px; color: #999; margin-left: 10px"
          >注：若存在已支付费用，则姓名和身份证号不能修改</span
        >
        <div class="true_btn" @click="confirmChange">确认修改</div>
        <button class="Log_out block_center" @click="leaveBtn">安全退出</button>
      </div>
      <van-popup
        v-model="isShowForm"
        closeable
        position="bottom"
        :style="{ height: '50%' }"
      >
        <div class="blue_font from_title">修改手机号</div>
        <login-form
          :isStyle01="true"
          @submit="update"
          :btnText="btnText"
          :isRegister="true"
          :is-submit-disabled-f="isSubmitDisabledF"
        ></login-form>
      </van-popup>
    </div>
    <Foot class="Foot"></Foot>
  </div>
</template>

<script>
import Foot from "../../components/Foot.vue";
import NavBar from "components/common/NavBar";
import LoginForm from "../login/component/LoginForm.vue";
import { updateTelPhone, updateStudentInfo } from "network/myprofile";
import { isNull } from "common/utils";
import { logOut } from "network/login";
import { getPersonalData } from "network/user";
// 引入vuex
import store from "../../store/index";
export default {
  name: "MyProfile",
  components: {
    NavBar,
    LoginForm,
    Foot,
  },
  data() {
    return {
      isShowForm: false, // 是否显示修改表单
      name: "",
      telPhone: "",
      cardNumber: "",
      btnText: "确认修改",
      isSubmitDisabledF: false,
      disabled: false,
      isPay: false,
    };
  },
  mounted() {
    document.body.style.backgroundColor = "#f6f6f6";
  },
  created() {
    console.log(this.$store.state.userInfo);
    // 获取缓存中的学员信息
    var userInfo = this.$store.state.userInfo || JSON.parse(localStorage.store).userInfo;
    if (!isNull(userInfo)) {
      console.log(userInfo);
      this.name = userInfo.name;
      this.telPhone = userInfo.tel;
      this.cardNumber = userInfo.idCard;
      this.isPay = userInfo.isPay;
      if (userInfo.name !== "未设置" && userInfo.idCard !== null)
        return (this.disabled = true);
    } else {
      this.getUserinfo();
    }
  },
  methods: {
    async getUserinfo() {
      this.$loading.show("");
      const result = await getPersonalData();
      console.log(result, "111123");
      if (result && result.code == 1) {
        this.$loading.hide();
        let userInfo = result.result;
        this.name = userInfo.name;
        this.telPhone = userInfo.tel;
        this.cardNumber = userInfo.idCard;
        this.isPay = userInfo.isPay;
      } else {
        this.$confirm.show(result.message);
        this.$loading.hide();
      }
    },
    //点击手机号弹出表单
    changeTel() {
      this.isShowForm = true;
    },
    // 修改密码提交
    update(val) {
      console.log(val);
      this.isSubmitDisabledF = true;
      // 修改手机号
      updateTelPhone(val.telInput, val.verfVal)
        .then((res) => {
          this.$loading.hide();
          if (res && res.code == 1) {
            this.isSubmitDisabledF = false;
            this.telPhone = val.telInput;
            this.$toast.show(res.message);
            this.isShowForm = false;
          } else {
            this.isSubmitDisabledF = false;
            this.$toast.show(res.message);
          }
        })
        .catch((err) => {
          this.isSubmitDisabledF = false;
          this.isShowForm = false;
          this.$toast.show("请确认验证码是否正确，或者重新获取!");
        });
    },
    // 我的资料修改提交
    async confirmChange() {
      if (!this.name) {
        this.$toast.show("请填写您的姓名");
        return;
      }
      if (!this.telPhone) {
        this.$toast.show("请填写您的手机号");
        return;
      }
      if (!this.cardNumber) {
        this.$toast.show("请填写您的身份证号");
        return;
      } else {
        const result = await updateStudentInfo(this.name, this.cardNumber);
        if (result && result.code == 1) {
          // await this.$confirm.show(result.message)
          this.$Dialog
            .confirm({
              title: result.message,
              showCancelButton: false,
              // message:
              //   "退出后需要重新登录",
            })
            .then(() => {
              // 存储用户信息
              let userInfo = {};
              userInfo.name = this.name;
              userInfo.tel = this.telPhone;
              userInfo.idCard = this.cardNumber;
              userInfo.myInterals = 0; //临时模拟总积分数据，接口须新增返给前端
              // 修改后的个人信息存储替换vuex和本地缓存
              store.commit("saveUserInfoStorage", userInfo);
              let localStore = JSON.parse(localStorage.store);
              localStore.userInfo = userInfo;
              window.localStorage.setItem("store", JSON.stringify(localStore));
              this.$router.push("/index");
            })
            .catch(() => {});
        } else {
          this.$confirm.show(result.message);
        }
      }
    },
    leaveBtn: function () {
      this.$Dialog
        .confirm({
          title: "确定退出登录吗",
          // message:
          //   "退出后需要重新登录",
        })
        .then(() => {
          this.$store.dispatch("logout");
          localStorage.clear();
          logOut("正在退出登录…");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
}
body {
  background-color: #f7f8fa;
}
.blue_bg {
  height: 96px;
  line-height: 96px;
  margin-top: -1px;
  background-color: #5391ff;
  color: #fff;
}
.content {
  position: relative;
  top: -6%;
  margin: 0 28px;
  background-color: #f7f8fa;
}
.myprofile_img img {
  width: 100%;
  position: relative;
}

.myprofile_info {
  margin-top: 24px;
  border-radius: 28px;
  background-color: #fff;
}
.myprofile_info .item_lable {
  line-height: 30px;
  padding: 35px 0;
  flex: 1;
}
.myprofile_info .input_item {
  line-height: 38px;
  padding: 0 28px;
}
.start_red {
  margin-right: 8px;
}
.myprofile_info .input_item:last-child {
  border-bottom: none;
}
.input_item {
  position: relative;
  font-size: 28px;
  border-bottom: 1px solid #eee;
}
.input_item .left_info {
  width: 400px;
  border: none;
  line-height: 30px;
  padding: 18px 0;
  margin: 18px 0;
  border-radius: 16px;
  padding-right: 50px;
  text-align: right;
  /* flex: 1; */
  box-sizing: border-box;
  background: #fff;
}
.bgc {
  background-color: #f3f3f3 !important;
}
.true_btn {
  height: 96px;
  line-height: 96px;
  text-align: center;
  margin: 84px 28px 0 28px;
  border-radius: 28px;
  font-size: 32px;
  font-weight: 500;
  border-radius: 20px;
  color: #5391ff;
  background: #f7f8fa;
  border: 1px solid #5391ff;
}

/* 退出登录 */
.Log_out {
  height: 96px;
  line-height: 96px;
  text-align: center;
  margin: 20px 28px 0 28px;
  border-radius: 28px;
  font-size: 32px;
  font-weight: 500;
  border: 1px solid #c8c9cc;
  border-radius: 20px;
  background: #f7f8fa;
  color: #969799;
}

.block_center {
  width: 92%;
}

/deep/.van-popup {
  padding: 66px 28px 63px 28px;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
}
/deep/.van-popup__close-icon {
  font-size: 28px;
}
/deep/.van-popup__close-icon--top-right {
  top: 28px;
  right: 28px;
}
.from_title {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 2px;
}
/deep/.van-icon-arrow {
  position: absolute;
  right: 28px;
  top: 40px;
}
.flex-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
